import {CommonService} from './../../../shared/utils/common.service';
import {UtilsService} from './../../../shared/utils/utils.service';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {moduloGaritas} from '../diccionarios/balanzaModulo.js';
import {ICedulaChofer} from '../modelos/ICedulaChofer';

@Injectable({
  providedIn: 'root'
})
export class CedulaChoferService {

  private diccionarioModulo: any;
  private url: string;
  private urlMaestros: string;

  constructor(private _util: UtilsService, private _commom: CommonService) {
    this.diccionarioModulo = moduloGaritas;
    this.url = this._util.getUrlBascula();
    this.urlMaestros = this._util.getDatosMaestros();
  }

  obtenerPorId(codMaterial: string): Observable<ICedulaChofer> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.cedulaChofer.obtenerPorId + codMaterial
    );
  }

  obtenerPorCedula(codMaterial: string): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.urlMaestros + this.diccionarioModulo.url.cedulaChofer.obtenerPorCedula + codMaterial
    );
  }
}
